import { Badge, Theme, Pattern, IndustryPreset } from './types';

export const PATTERNS: Pattern[] = [
  { id: 'none', name: 'None' },
  { id: 'grid', name: 'Subtle Grid' },
  { id: 'dots', name: 'Dotted' },
  { id: 'waves', name: 'Waves' },
  { id: 'glow', name: 'Ambient Glow' },
  { id: 'geometric', name: 'Geometric Shapes' },
];

export const THEMES: Theme[] = [
  {
    id: 'orbit-dark',
    name: 'Cosmic Slate',
    backgroundClass: 'bg-zinc-950',
    textClass: 'text-zinc-50',
    badgeStyle: 'glow',
  },
  {
    id: 'cloud-light',
    name: 'Pristine White',
    backgroundClass: 'bg-zinc-50',
    textClass: 'text-zinc-900',
    badgeStyle: 'solid',
  },
  {
    id: 'hacker',
    name: 'Terminal Black',
    backgroundClass: 'bg-black',
    textClass: 'text-zinc-300',
    badgeStyle: 'outline',
  },
  {
    id: 'midnight-purple',
    name: 'Midnight Onyx',
    backgroundClass: 'bg-zinc-900',
    textClass: 'text-zinc-100',
    badgeStyle: 'glow',
  }
];

export const BADGES: Badge[] = [
  { id: 'gen-ai', name: 'Gen AI Explorer', color: 'bg-purple-500', iconName: 'BrainCircuit' },
  { id: 'cloud-fund', name: 'Cloud Fundamentals', color: 'bg-blue-500', iconName: 'Cloud' },
  { id: 'k8s', name: 'Kubernetes Master', color: 'bg-blue-600', iconName: 'Ship' },
  { id: 'data-eng', name: 'Data Engineering', color: 'bg-emerald-500', iconName: 'Database' },
  { id: 'sec-spec', name: 'Security Specialist', color: 'bg-rose-500', iconName: 'ShieldCheck' },
  { id: 'ml-api', name: 'Machine Learning', color: 'bg-amber-500', iconName: 'Cpu' },
  { id: 'net-fund', name: 'Networking Pro', color: 'bg-cyan-500', iconName: 'Network' },
  { id: 'devops', name: 'DevOps Expert', color: 'bg-indigo-500', iconName: 'Infinity' },
  { id: 'arch', name: 'Cloud Architecture', color: 'bg-sky-500', iconName: 'Cuboid' },
  { id: 'serverless', name: 'Serverless Coder', color: 'bg-orange-500', iconName: 'Zap' },
  { id: 'analytics', name: 'Data Analytics', color: 'bg-teal-500', iconName: 'BarChart3' },
  { id: 'iot', name: 'IoT Developer', color: 'bg-lime-500', iconName: 'Wifi' },
];

export const PRESETS: IndustryPreset[] = [
  {
    id: 'data-science',
    name: 'Data Scientist',
    themeId: 'midnight-purple',
    patternId: 'glow',
    layout: 'centric',
    titlePattern: 'Data Scientist | AI & ML Specialist',
    fontFamily: 'serif',
  },
  {
    id: 'cloud-architect',
    name: 'Cloud Architect',
    themeId: 'orbit-dark',
    patternId: 'grid',
    layout: 'compact',
    titlePattern: 'Principal Cloud Architect',
    fontFamily: 'display',
  },
  {
    id: 'devops',
    name: 'DevOps Engineer',
    themeId: 'hacker',
    patternId: 'geometric',
    layout: 'compact',
    titlePattern: 'DevOps & SRE Engineer',
    fontFamily: 'mono',
  },
  {
    id: 'cloud-developer',
    name: 'Cloud Developer',
    themeId: 'cloud-light',
    patternId: 'waves',
    layout: 'centric',
    titlePattern: 'Cloud Native Developer',
    fontFamily: 'sans',
  }
];
